// extracted by mini-css-extract-plugin
export default {"wrapper":"_80f88dc2","header":"_7d6c4f6e","link":"_c987cf51","starRating":"_aa536742","ratingValue":"_d3bed7d"};